module.exports = __webpack_public_path__ + "static/media/search.59b1ba0a.svg";